<script lang="ts" setup>
withDefaults(
  defineProps<{
    title?: string | null
  }>(),
  { title: null }
)
</script>

<template>
  <div>
    <h4 v-if="title" class="mb-1 font-medium text-gray-700">
      {{ title }}
    </h4>

    <slot />
  </div>
</template>
